module.exports = require("@seddi/core");